var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-start align-end m-b-15"},[_c('select-column-position')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }